import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Typography,
    Chip,
    Grid,
    IconButton,
    InputBase,
    Paper,
    Divider,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import VerifiedIcon from "@mui/icons-material/Verified";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import SearchIcon from "@mui/icons-material/Search";
import LockIcon from "@mui/icons-material/Lock";
import SecurityIcon from '@mui/icons-material/Security';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PaidIcon from '@mui/icons-material/Paid';
import BlockIcon from '@mui/icons-material/Block';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import CustomAppBar from '../shared/CustomAppBar';
import { Campaign } from "@mui/icons-material";

const modulos = [
    {
        titulo: "Muro Alien Realty",
        descripcion: "Explora y gestiona la publicación de propiedades en venta o alquiler.",
        imagen: "/assets/images/list.png",
        etiquetas: ["Todos"],
        ruta: "/properties/home",
        icono: <VerifiedIcon color="primary" />,
    },
    {
        titulo: "Corresponsales",
        descripcion: "Gana dinero subiendo propiedades de forma sencilla y rápida.",
        imagen: "/assets/images/reporter.png",
        etiquetas: ["Brokers", "Hunters"],
        ruta: "",
        icono: <CameraAltIcon color="success" />,
    },
    {
        titulo: "Inventario de Propiedades",
        descripcion: "Registra, actualiza y lleva el control de tus propiedades mediante una interfaz intuitiva y fácil de usar.",
        imagen: "/assets/images/add-property.png",
        etiquetas: ["Clientes", "Brokers"],
        ruta: "/properties-inventory",
        icono: <MapsHomeWorkIcon color="info" />,
        activo: true,
    },
    {
        titulo: "Red de Brokers",
        descripcion: "Gestiona perfiles de brokers con su información de contacto y ubicación para una búsqueda eficiente.",
        imagen: "/assets/images/broker2.png",
        etiquetas: ["Brokers", "Inmobiliarias", "Dueños"],
        ruta: "/brokers",
        icono: <GroupAddIcon color="secondary" />,
    },
    {
        titulo: "CRM",
        descripcion: "Gestiona la información de los clientes, seguimiento, historial de interacciones y análisis de datos.",
        imagen: "/assets/images/crm.png",
        etiquetas: ["Clientes", "Brokers"],
        ruta: "/crm/requests",
        externo: false,
        icono: <DashboardIcon color="primary" />,
    },
    {
        titulo: "Gestión de Citas",
        descripcion: "Programa visitas a las propiedade mediante calendarios, recordatorios y confirmaciones de citas.",
        imagen: "/assets/images/schedule.png",
        etiquetas: ["Clientes", "Brokers"],
        ruta: "/appointments/home",
        icono: <CalendarMonthIcon color="primary" />,
       
    },
    {
        titulo: "Seguridad de Propiedades",
        descripcion: "Protege tus propiedades con servicios avanzados de seguridad.",
        imagen: "/assets/images/security2.png",
        etiquetas: ["Clientes"],
        ruta: "",
        activo: false,
        icono: <SecurityIcon color="warning" />,
    },
    {
        titulo: "Análisis Crediticio",
        descripcion: "Evalúa la capacidad financiera del comprador con precalificación.",
        imagen: "/assets/images/credit.png",
        etiquetas: ["Clientes", "Brokers"],
        ruta: "",
        activo: false,
        icono: <PaidIcon color="success" />,
    },
    {
        titulo: "Lista Negra",
        descripcion: "Controla transacciones con inquilinos y propiedades no confiables.",
        imagen: "/assets/images/blacklist.png",
        etiquetas: ["Clientes"],
        ruta: "",
        activo: false,
        icono: <BlockIcon color="error" />,
    },
    {
        titulo: "Control de Contratos",
        descripcion: "Genera contratos seguros con control de fechas y firma digital.",
        imagen: "/assets/images/contract.png",
        etiquetas: ["Clientes"],
        ruta: "",
        activo: false,
        icono: <AssignmentIcon color="primary" />,
    },
    {
        titulo: "Pasarela y Hacienda",
        descripcion: "Realiza pagos seguros y simplifica transacciones con brokers.",
        imagen: "/assets/images/payment2.png",
        etiquetas: ["Clientes"],
        ruta: "",
        activo: false,
        icono: <CreditCardIcon color="success" />,
    },
    {
        titulo: "Campañas de propiedades",
        descripcion: "Genera PDF profesionales de tus propiedades para compartir fácilmente.",
        imagen: "/assets/images/advertising.png",
        etiquetas: ["Brokers", "Dueños"],
        ruta: "/properties/campaign",
        activo: true,
        icono: <Campaign color="info" />,
    },
    {
        titulo: "Asistencia con IA",
        descripcion: "Optimiza procesos con asistencia automatizada de inteligencia artificial.",
        imagen: "/assets/images/ai2.png",
        etiquetas: ["Todos"],
        ruta: "",
        activo: false,
        icono: <SmartToyIcon color="info" />,
    },

];

export default function ModulosPage() {
    const [busqueda, setBusqueda] = useState("");
    const navigate = useNavigate();
    const { tokenKey, name, } = useAuth();

    const modulosFiltrados = modulos.filter((modulo) =>
        modulo.titulo.toLowerCase().includes(busqueda.toLowerCase())
    );

    return (
        <>
            <CustomAppBar />
            <Box sx={{ backgroundColor: "#ffff", minHeight: "100vh", pb: 4 }}>

                <Box sx={{ height: "10vh" }} /> {/* Ajusta según la altura real del AppBar */}
                <Divider key="divider2" />
                {/* Encabezado */}
                <Box
                    sx={{
                        backgroundColor: "#ffff",
                        color: "black",
                        padding: "12px 16px",
                        maxWidth: "100%",
                    }}
                >
                    {/* Bienvenida arriba, alineado a la izquierda */}
                    <Typography variant="h6" textAlign="left" sx={{ mb: 1 }}>
                        👽 Bienvenido, {tokenKey && name}
                    </Typography>

                    {/* Contenedor fila con subtítulo y barra */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        {/* Subtítulo a la izquierda */}
                        <Typography variant="h6" textAlign="left" sx={{ flexShrink: 0, ml: 1 }}>
                            Selecciona el módulo:
                        </Typography>

                        {/* Barra de búsqueda a la derecha */}
                        <Paper
                            component="form"
                            sx={{
                                p: "2px 8px",
                                display: "flex",
                                alignItems: "center",
                                width: 320,
                                borderRadius: 2,
                                backgroundColor: "white",
                            }}
                        >
                            <SearchIcon sx={{ color: "gray" }} />
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Buscar módulo..."
                                inputProps={{ "aria-label": "buscar módulo" }}
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                            />
                        </Paper>
                    </Box>
                </Box>

                {/* Contenido */}
                <Box mt={3} px={2}>
                    <Grid container spacing={2}>
                        {modulosFiltrados.length === 0 ? (
                            <Grid item xs={12}>
                                <Typography textAlign="center" mt={4}>
                                    No se encontraron módulos.
                                </Typography>
                            </Grid>
                        ) : (
                            modulosFiltrados.map((modulo: typeof modulos[0], index: number) => (
                                <Grid item xs={12} sm={6} md={4} key={index} sx={{ height: "100%", alignItems: "stretch" }}>
                                    <Box
                                        sx={{
                                            position: "relative",
                                            height: "100%",
                                            "&:hover .overlay": {
                                                opacity: 1,
                                            },
                                            "&:hover .card": {
                                                filter: modulo.activo === false ? "grayscale(100%)" : "none",
                                            },
                                        }}
                                    >
                                        {/* Overlay que aparece solo en hover */}
                                        {modulo.activo === false && (
                                            <Box
                                                className="overlay"
                                                sx={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    bgcolor: "rgba(0, 0, 0, 0.5)",
                                                    color: "white",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    zIndex: 2,
                                                    borderRadius: 3,
                                                    opacity: 0,
                                                    transition: "opacity 0.3s ease-in-out",
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                <LockIcon sx={{ fontSize: 40, mb: 1 }} />
                                                <Typography variant="h6" fontWeight="bold">
                                                    Próximamente
                                                </Typography>
                                                <Typography variant="body2">Módulo en desarrollo</Typography>
                                            </Box>
                                        )}

                                        <Card
                                           onClick={() => {
                                                if (modulo.activo === false) return;

                                                // Si es un módulo externo
                                                if (modulo.externo) {
                                                window.open(modulo.ruta, "_blank");
                                                return;
                                                }

                                                // Detectar si estamos dentro de /company/:companyId
                                                const match = window.location.pathname.match(/^\/company\/([^/]+)/);
                                                if (match) {
                                                const companyId = match[1];
                                                // Concatenar la ruta relativa del módulo
                                                navigate(`/company/${companyId}${modulo.ruta}`);
                                                } else {
                                                // Ruta normal
                                                navigate(modulo.ruta);
                                                }
                                            }}
                                            sx={{
                                                height: "100%",
                                                minHeight: 350,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                cursor: modulo.activo === false ? "not-allowed" : "pointer",
                                                borderRadius: 3,
                                                opacity: modulo.activo === false ? 0.5 : 1,
                                                pointerEvents: modulo.activo === false ? "none" : "auto",
                                                boxShadow: modulo.activo === false ? 1 : 3,

                                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                '&:hover': modulo.activo !== false ? {
                                                    transform: 'scale(1.03)',
                                                    boxShadow: 6,
                                                } : {},
                                                zIndex: 1,
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                image={modulo.imagen}
                                                alt={modulo.titulo}
                                                height="160"
                                                sx={{
                                                    objectFit: "contain",
                                                    backgroundColor: "#e6f2e6",
                                                }}
                                            />
                                            <CardContent sx={{ flexGrow: 1, height: "100%" }}>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Typography variant="h6" fontWeight="bold" >
                                                        {modulo.titulo}
                                                    </Typography>
                                                    {modulo.icono && <IconButton disabled>{modulo.icono}</IconButton>}
                                                </Box>
                                                <Typography variant="body2" color="text.secondary" mt={1}
                                                    sx={{
                                                        overflow: 'hidden',
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 3, // Limita a 3 líneas
                                                        WebkitBoxOrient: 'vertical',
                                                    }}
                                                >
                                                    {modulo.descripcion}
                                                </Typography>
                                                <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                                                    {modulo.etiquetas.map((etiqueta, i) => (
                                                        <Chip
                                                            key={i}
                                                            label={etiqueta}
                                                            size="small"
                                                            color={etiqueta === "Brokers" ? "error" : "info"}
                                                            variant="outlined"
                                                        />
                                                    ))}
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </Grid>
                            ))
                        )}
                    </Grid>
                </Box>
            </Box>
        </>

    );
}